import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	titleCmdbAssets: {
		defaultMessage: 'Assets',
		id: 'atlassian-navigation.insight.title-cmdb-assets',
		description: 'Title of the CMDB menu item.',
	},
});
